export const ADD_MENTION_RESOURCE = 'ADD_MENTION_RESOURCE';
export const REMOVE_MENTION_RESOURCE = 'REMOVE_MENTION_RESOURCE';
export const CLEAR_MENTION_RESOURCES = 'CLEAR_MENTION_RESOURCES';
export const RESET_MENTION_RESOURCES = 'RESET_MENTION_RESOURCES';
export const UPDATE_AI_CHANGE_RESOURCE_DATA = 'UPDATE_AI_CHANGE_RESOURCE_DATA';
export const REMOVE_AI_CHANGE_ITEM = 'REMOVE_AI_CHANGE_ITEM';
export const UPDATE_AI_CHANGE_FORM = 'UPDATE_AI_CHANGE_FORM';
export const UPDATE_AI_CHANGE_QUESTIONS = 'UPDATE_AI_CHANGE_QUESTIONS';
export const UPDATE_AI_PROCESSING_STATE = 'UPDATE_AI_PROCESSING_STATE';
export const REJECT_ALL_AI_CHANGES = 'REJECT_ALL_AI_CHANGES';
export const ACCEPT_ALL_AI_CHANGES = 'ACCEPT_ALL_AI_CHANGES';
export const UPLOAD_FILES = 'UPLOAD_FILES';
export const SNAPSHOT_CURRENT_MENTION_RESOURCES = 'SNAPSHOT_CURRENT_MENTION_RESOURCES';
